import PropTypes from 'prop-types';
import React from 'react';

function BreakWrapper({ softOrder, Component, ...rest }) {
  const details = {
    tacticName: 'BREAK',
    category: 'Setup',
    type: 'Break',
    domain: 'Underlying',
  };
  const priceToBreak = softOrder.priceToBreak;
  return <Component details={details} priceToBreak={priceToBreak} {...rest}/>;
}

BreakWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    priceToBreak: PropTypes.number
  })
};


export default BreakWrapper;
